import React, { FC } from "react";

import Link from "../../components/styled/Link";
import { ActivityLog } from "../../store/pomeriumApi";

interface EntityDescriptionProps {
  activityLog: ActivityLog;
}

const EntityDescription: FC<EntityDescriptionProps> = ({ activityLog }) => {
  switch (activityLog?.entity?.type) {
    case "domain":
      return <>{activityLog?.entity?.data?.name}</>;
    case "key_pair":
      return (
        <Link to={`/app/management/certificates/${activityLog?.entity?.id}`}>
          {activityLog?.entity?.data?.name}
        </Link>
      );
    case "namespace":
      return <>{activityLog?.entity?.data?.name}</>;
    case "organization":
      return <>{activityLog?.entity?.data?.name}</>;
    case "policy":
      return (
        <Link to={`/app/management/policies/${activityLog?.entity?.id}/edit`}>
          {activityLog?.entity?.data?.name}
        </Link>
      );
    case "route":
      return (
        <Link to={`/app/management/routes/${activityLog?.entity?.id}/edit`}>
          {activityLog?.entity?.data?.name}
        </Link>
      );
    case "settings":
      return <Link to="/app/settings">cluster settings</Link>;
    default:
      return <>entity</>;
  }
};
export default EntityDescription;
